import { SafeAreaView } from "react-native-safe-area-context";
import { Text, View, XStack } from "tamagui";
import { customColorTokens } from "../../../../tamagui.config";
import React, { useEffect, useState } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

type HeaderProps = {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  headerCenter?: React.ReactNode;
  headerRight?: React.ReactNode;
  hideBorder?: boolean;
};

export const Header = ({
  title,
  subtitle,
  headerCenter,
  headerRight,
  hideBorder = false,
}: HeaderProps) => {
  return (
    <SafeAreaView
      edges={["top"]}
      style={{
        backgroundColor: customColorTokens.brandParchment,
        zIndex: 100,
      }}
    >
      <XStack
        justifyContent="space-between"
        alignItems="center"
        px="$4"
        pb={18}
        bg={customColorTokens.brandParchment}
        borderBottomWidth={hideBorder ? 0 : 1}
        $platform-web={{ paddingTop: "$3" }}
        pos="relative"
        h={40}
      >
        <View
          justifyContent="center"
          flexGrow={1}
          alignItems="flex-start"
          flexShrink={1}
        >
          {typeof title === "string" ? (
            <Text
              $platform-web={{ fontSize: 20 }}
              $platform-native={{ fontSize: "$2" }}
              textTransform="uppercase"
              fontWeight={900}
              fontFamily="$heading"
              adjustsFontSizeToFit
              w={"100%"}
            >
              {title}
            </Text>
          ) : title ? (
            title
          ) : null}
          {subtitle ? (
            <Text
              fontSize={12}
              fontFamily="$body"
              textTransform="uppercase"
              wordWrap="break-word"
            >
              {subtitle}
            </Text>
          ) : null}
        </View>
        <View flexGrow={1}>{headerCenter && headerCenter}</View>
        <View
          flexGrow={1}
          flexShrink={0}
          justifyContent="center"
          alignItems="flex-end"
        >
          {headerRight ? headerRight : <View h="4" w="4" bg="black" />}
        </View>
      </XStack>
    </SafeAreaView>
  );
};
